import type { Pagination, PourAvailability } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'menu/pour-availabilities';

export function getPourAvailabilities(query?: PourAvailability.SearchQuery) {
    return api.get<Pagination<PourAvailability>>(`${rootPath}`, query);
}

export function getPourAvailability(id: number) {
    return api.get<PourAvailability.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postPourAvailability(data: PourAvailability.CreateRequest) {
    return api.post<PourAvailability>(`${rootPath}`, data);
}

export function putPourAvailability(
    id: number,
    data: PourAvailability.UpdateRequest
) {
    return api.put<PourAvailability>(`${rootPath}/${id}`, data);
}

export function deletePourAvailability({ id }: PourAvailability.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
